import { useState } from 'react';
import './EmbedBuilder.css';

const PRESETS = [
  { name: 'Orange', hex: 'ff7a1a' },
  { name: 'Indigo', hex: '6c5ce7' },
  { name: 'Teal',   hex: '00c2a8' },
  { name: 'Coral',  hex: 'f5564a' },
  { name: 'Slate',  hex: '1e2430' },
];
const DETAILS = [
  { key: 'map',  label: 'Map' },
  { key: 'dist', label: 'Distance' },
  { key: 'time', label: 'Time / Date' },
  { key: 'curv', label: 'Curviness' },
  { key: 'loc',  label: 'Location' },
];

export function EmbedBuilder({ kind, id }) {
  const [theme, setTheme]   = useState('light');
  const [accent, setAccent] = useState('ff7a1a');
  const [show, setShow]     = useState({ map: true, dist: true, time: true, curv: true, loc: true });
  const [copied, setCopied] = useState(false);

  const origin = window.location.origin;
  const showKeys = DETAILS.filter(d => show[d.key]).map(d => d.key).join(',');
  const src = `${origin}/embed/${kind}/${id}?theme=${theme}&accent=${accent}&show=${showKeys}`;
  const snippet = `<iframe src="${src}" width="100%" height="178" style="border:0;border-radius:14px;max-width:520px" loading="lazy" title="Motoroam ${kind}"></iframe>`;

  const copy = async () => {
    try { await navigator.clipboard.writeText(snippet); setCopied(true); setTimeout(() => setCopied(false), 1800); } catch { /* blocked */ }
  };

  return (
    <div className="embuild">
      <div className="embuild__preview">
        <iframe src={src} title="Embed preview" loading="lazy" />
      </div>

      <div className="embuild__row">
        <span className="embuild__label">Theme</span>
        <div className="embuild__seg">
          <button className={theme === 'light' ? 'on' : ''} onClick={() => setTheme('light')}>Light</button>
          <button className={theme === 'dark' ? 'on' : ''} onClick={() => setTheme('dark')}>Dark</button>
        </div>
      </div>

      <div className="embuild__row">
        <span className="embuild__label">Accent</span>
        <div className="embuild__swatches">
          {PRESETS.map(p => (
            <button key={p.hex} className={`embuild__swatch${accent === p.hex ? ' on' : ''}`} style={{ background: `#${p.hex}` }} onClick={() => setAccent(p.hex)} title={p.name} />
          ))}
          <input type="color" className="embuild__color" value={`#${accent}`} onChange={e => setAccent(e.target.value.replace('#', ''))} title="Custom" />
        </div>
      </div>

      <div className="embuild__row embuild__row--wrap">
        <span className="embuild__label">Show</span>
        <div className="embuild__chks">
          {DETAILS.map(d => (
            <label key={d.key} className={`embuild__chk${show[d.key] ? ' on' : ''}`}>
              <input type="checkbox" checked={show[d.key]} onChange={e => setShow(s => ({ ...s, [d.key]: e.target.checked }))} />
              {d.label}
            </label>
          ))}
        </div>
      </div>

      <button className="embuild__copy" onClick={copy}>
        {copied ? 'Copied!' : 'Copy embed code'}
      </button>
    </div>
  );
}
